/** @format */

/**
 * Route API handles for breaking value-level cycles between route files and
 * their callers. Importing `Route` directly from a route file creates a graph
 * where the callers chain back through the route's own children; `getRouteApi`
 * uses only the route id string, so consumers can pull useSearch/useParams/
 * useNavigate without importing the Route value.
 */

import { getRouteApi } from "@tanstack/react-router";

export const RunRouteApi = getRouteApi("/run/$runID");

export const SeriesStandingsRouteApi = getRouteApi("/series/$series/standings");
